import { render, staticRenderFns } from "./AskAthena.vue?vue&type=template&id=2e0fcbc7&scoped=true&"
import script from "./AskAthena.vue?vue&type=script&lang=js&"
export * from "./AskAthena.vue?vue&type=script&lang=js&"
import style0 from "./AskAthena.vue?vue&type=style&index=0&id=2e0fcbc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0fcbc7",
  null
  
)

export default component.exports